import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Create axios instance with auth header
const createAuthApi = () => {
  const token = localStorage.getItem('token');
  return axios.create({
    baseURL: API_URL,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

// Public CMS API (no auth required)
export const publicCmsAPI = {
  // Site Settings
  getSettings: () => axios.get(`${API_URL}/api/public/settings`),
  
  // Pages
  getPage: (slug) => axios.get(`${API_URL}/api/public/pages/${slug}`),
  
  // Services
  getServices: (featuredOnly = false) => 
    axios.get(`${API_URL}/api/public/services`, { params: { featured_only: featuredOnly } }),
  getService: (slug) => axios.get(`${API_URL}/api/public/services/${slug}`),
  
  // Formations
  getFormations: (featuredOnly = false) => 
    axios.get(`${API_URL}/api/public/formations`, { params: { featured_only: featuredOnly } }),
  getFormation: (slug) => axios.get(`${API_URL}/api/public/formations/${slug}`),
  
  // Team
  getTeam: (featuredOnly = false) => 
    axios.get(`${API_URL}/api/public/team`, { params: { featured_only: featuredOnly } }),
  getTeamMember: (slug) => axios.get(`${API_URL}/api/public/team/${slug}`),
  
  // Projects
  getProjects: (featuredOnly = false, category = null) => 
    axios.get(`${API_URL}/api/public/projects`, { params: { featured_only: featuredOnly, category } }),
  getProject: (slug) => axios.get(`${API_URL}/api/public/projects/${slug}`),
  
  // Partners
  getPartners: () => axios.get(`${API_URL}/api/public/partners`),
};

// Admin CMS API (auth required)
export const adminCmsAPI = {
  // Site Settings
  updateSettings: (data) => createAuthApi().put('/api/cms/settings', data),
  
  // Pages
  listPages: () => createAuthApi().get('/api/cms/pages'),
  getPage: (slug) => createAuthApi().get(`/api/cms/pages/${slug}`),
  createPage: (data) => createAuthApi().post('/api/cms/pages', data),
  updatePage: (slug, data) => createAuthApi().put(`/api/cms/pages/${slug}`, data),
  updatePageSection: (slug, sectionKey, data) => 
    createAuthApi().put(`/api/cms/pages/${slug}/sections/${sectionKey}`, data),
  deletePage: (slug) => createAuthApi().delete(`/api/cms/pages/${slug}`),
  
  // Services
  listServices: () => createAuthApi().get('/api/cms/services'),
  createService: (data) => createAuthApi().post('/api/cms/services', data),
  updateService: (id, data) => createAuthApi().put(`/api/cms/services/${id}`, data),
  deleteService: (id) => createAuthApi().delete(`/api/cms/services/${id}`),
  reorderServices: (orderData) => createAuthApi().put('/api/cms/services/reorder', orderData),
  
  // Formations
  listFormations: () => createAuthApi().get('/api/cms/formations'),
  createFormation: (data) => createAuthApi().post('/api/cms/formations', data),
  updateFormation: (id, data) => createAuthApi().put(`/api/cms/formations/${id}`, data),
  deleteFormation: (id) => createAuthApi().delete(`/api/cms/formations/${id}`),
  reorderFormations: (orderData) => createAuthApi().put('/api/cms/formations/reorder', orderData),
  
  // Team
  listTeam: () => createAuthApi().get('/api/cms/team'),
  createTeamMember: (data) => createAuthApi().post('/api/cms/team', data),
  updateTeamMember: (id, data) => createAuthApi().put(`/api/cms/team/${id}`, data),
  deleteTeamMember: (id) => createAuthApi().delete(`/api/cms/team/${id}`),
  reorderTeam: (orderData) => createAuthApi().put('/api/cms/team/reorder', orderData),
  
  // Projects
  listProjects: () => createAuthApi().get('/api/cms/projects'),
  createProject: (data) => createAuthApi().post('/api/cms/projects', data),
  updateProject: (id, data) => createAuthApi().put(`/api/cms/projects/${id}`, data),
  deleteProject: (id) => createAuthApi().delete(`/api/cms/projects/${id}`),
  
  // Partners
  listPartners: () => createAuthApi().get('/api/cms/partners'),
  createPartner: (data) => createAuthApi().post('/api/cms/partners', data),
  updatePartner: (id, data) => createAuthApi().put(`/api/cms/partners/${id}`, data),
  deletePartner: (id) => createAuthApi().delete(`/api/cms/partners/${id}`),
  
  // Media
  uploadMedia: (file, folder = 'general', altText = null) => {
    const formData = new FormData();
    formData.append('file', file);
    return createAuthApi().post('/api/cms/media/upload', formData, {
      params: { folder, alt_text: altText },
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  listMedia: (folder = null) => 
    createAuthApi().get('/api/cms/media', { params: { folder } }),
  deleteMedia: (id) => createAuthApi().delete(`/api/cms/media/${id}`),
};

export default { publicCmsAPI, adminCmsAPI };
